module.exports = __webpack_public_path__ + "img/Jennifer&Marcus-10.5e35bb73.jpg";